import { Card, Row, Col } from "antd";
import CustomText from '../../../CustomText';

export default function SubscriptionDefault ({ discount }) {
  return <Card
  bordered={true}
  className="criclebox tablespace mb-16 card-cancel-subscription"
>
  { discount && <Row
    className="subscription-cancelled-card"
    gutter={[30, 30]}
  >
    <Col span="8">
      <h4>Coupon ID</h4>
      <CustomText
        dataSet={discount}
        property1={'stripeCouponId'}
      />
      {
        discount?.stripeCouponId &&
          <strong><a
            href={"https://dashboard.stripe.com/coupons/" + discount?.stripeCouponId}
            title="Open in Stripe"
            target="_blank"
          >&nbsp;<small>open</small></a></strong>
      }
    </Col>
    <Col span="8">
      <h4>Percent Off</h4>
      <CustomText
        dataSet={discount}
        property1={'percentOff'}
      />
    </Col>
    <Col span="8">
      <h4>Duration</h4>
      <CustomText
        dataSet={discount}
        property1={'duration'}
      />
    </Col>
  </Row> }
  { !discount && <strong>No discount applied</strong>}
</Card>
}